import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import {
	base64ToFile,
	ImageCroppedEvent,
	ImageCropperComponent,
	ImageCropperModule,
} from 'ngx-image-cropper';
import { ICropDialogData } from '@core/services/au-dialog.service';
import { IconSnackBarService } from '@core/services/icon-snack-bar.service';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { NgClass } from '@angular/common';
import { AuTechnoBtnComponent } from '../../../shared/ui-components/au-techno-btn/au-techno-btn.component';
import { MatButton } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { FileFormatContentTypeMap } from '@app/shared/ui-components/au-file-loader/helpers/file-utilities';

@Component({
	templateUrl: './image-cropper-dialog.component.html',
	styleUrls: ['./image-cropper-dialog.component.scss'],
	imports: [
		MatIcon,
		MatDialogClose,
		MatRipple,
		NgClass,
		ImageCropperModule,
		AuTechnoBtnComponent,
		MatButton,
		NgxTolgeeModule,
	],
})
export class ImageCropperDialogComponent implements OnInit {
	@ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

	imageChangedEvent: any = '';
	croppedImage: any = '';
	droppedImageFile: File;
	isFileSelected = false;
	fileCouldBeDropped = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ICropDialogData,
		private dialogRef: MatDialogRef<ImageCropperDialogComponent>,
		private notify: IconSnackBarService
	) {}

	ngOnInit(): void {
		this.checkDragNDropAvailable();
		this.preventBrowserToOpenTheDropFile();
	}

	private checkDragNDropAvailable() {
		const div = document.createElement('div');

		// This line could be used to handle cases where browsers don't support
		// drag & drop functionality
		if ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) {
			console.info('Drag and Drop API is supported!');
		}
	}

	private preventBrowserToOpenTheDropFile() {
		window.addEventListener('dragover', ev => ev.preventDefault());
		window.addEventListener('drop', e => e.preventDefault());
	}

	private imageHasRightType(file): boolean {
		const imageTypes = [
			FileFormatContentTypeMap.PNG,
			FileFormatContentTypeMap.JPEG,
			FileFormatContentTypeMap.JPEG,
		];
		return imageTypes.includes(file.type);
	}

	// We need this event.preventDefault() as DOM elements by default disable DnD
	allowDrop(event: DragEvent) {
		event.preventDefault();
		event.dataTransfer.dropEffect = 'link';
		this.fileCouldBeDropped = true;
	}

	onDragFileEnter(event: DragEvent) {
		event.preventDefault();
	}

	onDragFileLeave(event: DragEvent) {
		event.preventDefault();
		this.fileCouldBeDropped = false;
	}

	handleImageDrop(event: DragEvent) {
		event.preventDefault();

		if (event.dataTransfer.files && event.dataTransfer.files[0]) {
			const file = event.dataTransfer.files[0];

			if (!this.imageHasRightType(file)) {
				this.fileCouldBeDropped = false;
				this.notify.error(`Only images of type '.png', '.jpg' , '.jpeg' are allowed`);

				return;
			}

			this.isFileSelected = true;
			this.droppedImageFile = file;
		}
	}

	onFileChanged(event: Event) {
		this.imageChangedEvent = event;
		const target = event.target as HTMLInputElement;

		if (target.files && target.files[0]) {
			const file = target.files[0];

			if (!this.imageHasRightType(file)) {
				this.fileCouldBeDropped = false;
				this.notify.error(`Only images of type '.png', '.jpg' are allowed`);

				return;
			}

			this.isFileSelected = true;
		}
	}

	onImageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
		const imgFile = base64ToFile(event.base64);

		this.dialogRef.close(imgFile);
	}

	cropAndUpload() {
		this.imageCropper.crop();
	}

	close() {
		this.dialogRef.close();
	}
}
